// import React, { useState, useEffect } from 'react';
// import { Grid, TextField } from '@mui/material';
// import Button from 'react-bootstrap/Button';
// import APIService from '../../../../APIService';
// import swal from 'sweetalert';
// import { Table } from 'react-bootstrap';

// export default function CGRF() {
//   const [cgrf, setCgrf] = useState([])
//   const [caption, setCaption] = useState("");
//   const [description, setDescription] = useState("");
//   const [fileUpload, setFileUpload] = useState("");

//   const [cgrfId, setCgrfId] = useState("");
//   const [isEditing, setIsEditing] = useState(false);

//   useEffect(() => {
//     APIService.get('cgrf').then((response) => {
//       setCgrf(response.data);
//     });
//   }, []);

//   const handleFileChange = (e) => {
//     if (e.target.files) {
//       setFileUpload(e.target.files[0]);
//     }
//   }

//   const handleEdit = (itemId, caption, description) => {
//     setIsEditing(true);
//     setCgrfId(itemId);
//     setCaption(caption);
//     setDescription(description)
//   };


//   const handleDelete = (itemId) => {
//     // e.preventDefault();
//     swal({
//       title: "Are you sure?",
//       text: "You want to delete this item?",
//       icon: "warning",
//       dangerMode: true,
//     }).then((willDelete) => {
//       if (willDelete) {
//         APIService.delete(`cgrf/${itemId}`).then((response) => {
//           swal("Success", response.message, "success", {
//             buttons: false,
//             timer: 2000,
//           }).then((value) => {
//             window.location.href = "/cgrf";
//           });
//         });
//       }
//     });
//   };

//   const handleSubmit = async (e) => {

//     e.preventDefault();
//     const formData = new FormData();
//     formData.append("caption", caption);
//     formData.append("description", description);
//     formData.append("image_upload", fileUpload);

//     if (isEditing) {
//       var response = await APIService.put(formData, `cgrf/${cgrfId}`);
//     } else {
//       var response = await APIService.post(formData, "cgrf");
//     }

//     if (response.success) {
//       swal("Success", response.message, "success", {
//         buttons: false,
//         timer: 2000,
//       }).then((value) => {
//         window.location.href = "/cgrf";
//       });
//     } else {
//       swal("Failed", response.message, "error");
//     }
//   }
//   return (
//     <div>
//       <h2 className="organisation-head">CGRF</h2>
//       <form noValidate onSubmit={handleSubmit}>
//         <Grid container spacing={3} style={{ marginTop: 10 }}>
//           <Grid item xs={12} sm={6} lg={4}>
//             <p id="labels">Caption</p>
//             <TextField
//               name="caption"
//               label="Caption"
//               variant="outlined"
//               fullWidth
//               value={caption}
//               onChange={e => setCaption(e.target.value)}
//             />
//           </Grid>
//           <Grid item xs={12} sm={6} lg={4}>
//             <p id="labels">Upload Image</p>
//             <TextField
//               name="upload-photo"
//               type="file"
//               onChange={handleFileChange}
//             />
//           </Grid>
//         </Grid>
//         <Grid container spacing={3} style={{ marginTop: 10 }}>
//           <Grid item xs={12} sm={6} lg={12} md={8}>
//             <p id="labels">Decription</p>
//             <TextField
//               fullWidth
//               id="outlined-multiline-static"
//               label="Decription"
//               multiline
//               rows={3}
//               value={description}
//               onChange={e => setDescription(e.target.value)}
//             />
//           </Grid>
//         </Grid>
//         <Button style={{ marginTop: 20 }} variant="primary" type="submit">Submit</Button>{' '}
//       </form>
//       <Table striped bordered hover variant="light">
//         <thead>
//           <tr>
//             <th>Sl No</th>
//             <th>Caption</th>
//             <th>Description</th>
//             <th>Edit</th>
//             <th>Delete</th>
//           </tr>
//         </thead>
//         <tbody>
//           {cgrf.map((cg, index) => (
//             <tr key={cg.id}>
//               <td>{index + 1}</td>
//               <td>{cg.caption}</td>
//               <td>{cg.description}</td>
//               <td><button className='tablebutton'
//                 onClick={() => handleEdit(cg.id, cg.caption, cg.description)}
//               >Edit</button></td>
//               <td><button className='tablebutton'
//                 onClick={() => handleDelete(cg.id)}>Delete</button></td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>
//     </div>
//   )
// }








import React, { useState, useEffect } from 'react';
import { Grid, TextField } from '@mui/material';
import Button from 'react-bootstrap/Button';
import APIService from '../../../../APIService';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';

export default function CGRF() {
  const [cgrf, setCgrf] = useState([]);
  const [caption, setCaption] = useState("");
  const [description, setDescription] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");
  const [jurisdiction, setJurisdiction] = useState("");
  const [contact_number, setContactNumber] = useState("");
  const [mail_id, setMailId] = useState("");
  const [fileUpload, setFileUpload] = useState(null);
  const [cgrfId, setCgrfId] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchCgrf();
  }, []);

  const fetchCgrf = () => {
    APIService.get('cgrf').then((response) => {
      setCgrf(response.data || []);
    }).catch(error => {
      console.error("Fetch CGRF error:", error);
      swal("Error", "Failed to fetch CGRF data", "error");
    });
  };

  const handleFileChange = (e) => {
    setFileUpload(e.target.files[0]);
  };

  const handleEdit = (item) => {
    setIsEditing(true);
    setCgrfId(item.id);
    setCaption(item.caption || "");
    setDescription(item.description || "");
    setSortOrder(item.sort_order || "");
    setName(item.name || "");
    setDesignation(item.designation || "");
    setJurisdiction(item.jurisdiction || "");
    setContactNumber(item.contact_number || item.mobile || "");
    setMailId(item.mail_id || item.email || "");
    setFileUpload(null); // Reset file upload when editing
  };

  const handleDelete = (itemId) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this item?",
      icon: "warning",
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        APIService.delete(`cgrf/${itemId}`).then((response) => {
          swal("Success", response.message || "Deleted successfully", "success", {
            buttons: false,
            timer: 2000,
          }).then(() => {
            fetchCgrf();
          });
        }).catch(error => {
          console.error("Delete error:", error);
          swal("Error", "Failed to delete item", "error");
        });
      }
    });
  };
  const changePosition = (direction, itemId) => {
    APIService.post([], `change-position/${direction}/cgrf/${itemId}`)
      .then((response) => {
        if (response.success) {
          fetchCgrf();
        }
      })
      .catch(error => {
        console.error('Position change error:', error);
        swal("Error", "Failed to change position", "error");
      });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validate required fields
    if (!caption || !name || !designation || !jurisdiction || !contact_number || !mail_id) {
      swal("Error", "Please fill all required fields", "error");
      return;
    }
  
    // Validate image (only required for new entries)
    if (!isEditing && !fileUpload) {
      swal("Error", "Please upload an image", "error");
      return;
    }
  
    if (fileUpload && !fileUpload.name.match(/\.(jpg|jpeg|png)$/i)) {
      swal("Error", "Please upload a valid JPG/PNG image", "error");
      return;
    }
  
    // Validate email format
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail_id)) {
      swal("Error", "Invalid email format", "error");
      return;
    }
  
    // Validate contact number
    if (!/^\d{10,}$/.test(contact_number)) {
      swal("Error", "Please enter a valid contact number (minimum 10 digits)", "error");
      return;
    }
  
    const formData = new FormData();
    formData.append("caption", caption);
    formData.append("description", description);
    formData.append("sort_order", sortOrder);
    formData.append("name", name);
    formData.append("designation", designation);
    formData.append("jurisdiction", jurisdiction);
    formData.append("contact_number", contact_number);
    formData.append("mail_id", mail_id);
    
    if (fileUpload) {
      formData.append("image_upload", fileUpload);
    }
    
    // Optional fields
    formData.append("is_active", "1");
    formData.append("created_by", "admin");
  
    try {
      let response;
      if (isEditing) {
        response = await APIService.put(formData, `cgrf/${cgrfId}`);
      } else {
        response = await APIService.post(formData, 'cgrf');
      }
  
      if (response.success || response.message) {
        swal("Success", response.message || "Operation successful", "success");
        resetForm();
        fetchCgrf();
      } else {
        swal("Failed", response.message || "Operation failed", "error");
      }
    } catch (error) {
      console.error("API Error:", error);
      const errorMessage = error.response?.data?.message || "An error occurred";
      swal("Error", errorMessage, "error");
    }
  };

  const resetForm = () => {
    setCaption("");
    setDescription("");
    setSortOrder("");
    setName("");
    setDesignation("");
    setJurisdiction("");
    setContactNumber("");
    setMailId("");
    setFileUpload(null);
    setCgrfId("");
    setIsEditing(false);
  };


  return (
    <div>
      <h2 className="organisation-head">CGRF</h2>
      <form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Caption*</p>
            <TextField
              name="caption"
              label="Caption"
              variant="outlined"
              fullWidth
              required
              value={caption}
              onChange={e => setCaption(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Sort Order</p>
            <TextField
              name="sort_order"
              label="Sort Order"
              variant="outlined"
              fullWidth
              type="number"
              value={sortOrder}
              onChange={e => setSortOrder(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Name*</p>
            <TextField
              name="name"
              label="Name"
              variant="outlined"
              fullWidth
              required
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Designation*</p>
            <TextField
              name="designation"
              label="Designation"
              variant="outlined"
              fullWidth
              required
              value={designation}
              onChange={e => setDesignation(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Jurisdiction*</p>
            <TextField
              name="jurisdiction"
              label="Jurisdiction"
              variant="outlined"
              fullWidth
              required
              value={jurisdiction}
              onChange={e => setJurisdiction(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Contact Number*</p>
            <TextField
              name="contact_number"
              label="Contact Number"
              variant="outlined"
              fullWidth
              required
              type="tel"
              value={contact_number}
              onChange={e => setContactNumber(e.target.value)}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Email*</p>
            <TextField
              name="mail_id"
              label="Email"
              variant="outlined"
              fullWidth
              required
              type="email"
              value={mail_id}
              onChange={e => setMailId(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Upload Image{!isEditing && '*'}</p>
            <input
              name="image_upload"
              type="file"
              accept="image/jpeg, image/png"
              onChange={handleFileChange}
              required={!isEditing}
              style={{ display: 'block' }}
            />
            {isEditing && <small>Leave empty to keep current image</small>}
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={12} lg={12}>
            <p id="labels">Description</p>
            <TextField
              fullWidth
              name="description"
              label="Description"
              multiline
              rows={3}
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </Grid>
        </Grid>

        <Button style={{ marginTop: 20 }} variant="primary" type="submit">
          {isEditing ? "Update" : "Submit"}
        </Button>{' '}
        {isEditing && (
          <Button style={{ marginTop: 20 }} variant="secondary" onClick={resetForm}>
            Cancel
          </Button>
        )}
      </form>

      <Table striped bordered hover variant="light" style={{ marginTop: 20 }}>
        <thead>
          <tr>
            <th>Sl No</th>
            <th style={{width:'10%'}}>Caption</th>
            <th style={{width:'20%'}}>Description</th>
            <th style={{width:'10%'}}>Name</th>
            <th style={{width:'10%'}}>Designation</th>
            <th style={{width:'10%'}}>Jurisdiction</th>
            <th style={{width:'10%'}}>Contact</th>
            <th style={{width:'10%'}}>Email</th>
            <th style={{width:'5%'}}>Sort Order</th>
            <th style={{width:'5%'}}>Image</th>
            <th style={{width:'10%'}}>Actions</th>
            <th >Move Up</th>
            <th >Move Down</th>

          </tr>
        </thead>
        <tbody>
          {cgrf.map((cg, index) => (
            <tr key={cg.id}>
              <td>{index + 1}</td>
              <td style={{width:'10%'}}>{cg.caption}</td>
              <td style={{width:'20%'}}>{cg.description}</td>
              <td style={{width:'10%'}}>{cg.name}</td>
              <td style={{width:'10%'}}>{cg.designation}</td>
              <td style={{width:'10%'}}>{cg.jurisdiction}</td>
              <td style={{width:'10%'}}>{cg.contact_number }</td>
              <td style={{width:'10%'}}>{cg.mail_id}</td>
              <td style={{width:'5%'}}>{cg.sort_order}</td>
              <td style={{width:'5%'}}>
                {cg.image_url ? (
                  <img 
                    src={cg.image_url} 
                    alt="CGRF" 
                    style={{ maxWidth: '50px', maxHeight: '50px' }} 
                  />
                ) : cg.image ? (
                  <img 
                    src={cg.image} 
                    alt="CGRF" 
                    style={{ maxWidth: '50px', maxHeight: '50px' }} 
                  />
                ) : 'N/A'}
              </td>
              <td style={{width:'10%'}}>
                <button className='tablebutton' onClick={() => handleEdit(cg)}>
                  Edit
                </button>
                <button 
                  className='tablebutton' 
                  style={{ marginLeft: '5px' }}
                  onClick={() => handleDelete(cg.id)}
                >
                  Delete
                </button>
              </td>
              <td>
                <button
                  className='move-btn'
                  onClick={() => changePosition("up", cg.id)}
                >
                  <img width="32" height="32" src="https://img.icons8.com/external-kmg-design-glyph-kmg-design/32/external-up-arrow-arrows-kmg-design-glyph-kmg-design.png" alt="external-up-arrow-arrows-kmg-design-glyph-kmg-design" />
                </button>
              </td>
              <td>
                <button
                  className='move-btn'
                  onClick={() => changePosition("down", cg.id)}
                >
                  <img width="36" height="40" src="https://img.icons8.com/fluency-systems-filled/48/thick-arrow-pointing-down.png" alt="thick-arrow-pointing-down" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}